export const AMDOCS_CONSTANTS = {
  PKCE_EXPIRATION: 'pkce_expiration',
  TOKEN_KEY: 'open_id_token',
  TOKEN_EXPIRATION_KEY: 'open_id_token_expiration',
  CAS_TOKEN_KEY: 'cas_token',
  CAS_TOKEN_EXPIRATION_KEY: 'cas_token_expiration',
  ACCESS_KEY_ID: 'AccessKeyId',
  SECRET_ACCESS_KEY: 'SecretAccessKey',
  SESSION_TOKEN: 'SessionToken',
  EXPIRATION: 'expiration',
  DIRECT_LINE_TOKEN: 'direct_line_token',
  DIRECT_LINE_SESSION_ID: 'direct_line_session_id',
  DIRECT_LINE_TOKEN_EXPIRATION: 'direct_line_token_expiration',
  SHOW_NEW_VERSION_ALERT_EVENT: 'show-new-version-alert-event',
  API_ERROR_EVENT: 'global-api-error-event',
  RELOAD_TIME: 30
};

export const NAVIGATOR_CONSTANTS = {
  SOURCE_ARTICLE_WORD_LIMIT: 72,
  SOURCE_ARTICLE_WORD_TRUNCATE: 57,
  SOURCE_ARTICLE_RELEVANT: 'relevant',
  SOURCE_ARTICLE_ADDITIONAL: 'additional',
  // SERVICE_WORKER_TEXT: 'A new version is available. Please clear cache to update to the latest version',//'A new version is available. Please reload the page to update to the latest version.',
  SERVICE_WORKER_TEXT:
    'A new version is available. Please reload the page to update to the latest version.',
  SERVICE_WORKER_UNDER:
    'Application is in unrecoverable state. Reloading to avoid chunk load issue.',
};

export const CHAT_CONSTANTS = {
  DEFAULT_ERROR_MESSAGE: 'An unknown error occurred. Please try again later.',
  TOAST_ERROR_LABEL: 'toast-error',
  TOAST_INFO_LABEL: 'toast-info',
  TOAST_SUCCESS_LABEL: 'toast-success',
  TOAST_ERROR_COLOR: 'red',
  TOAST_INFO_COLOR: 'blue',
  TOAST_SUCCESS_COLOR: 'green',
  TOAST_NEW_CHAT:
    'You cannot continue the current conversation, Please click “New Chat” to start new conversation.',
  TOAST_POSTING_ACTIVITY: 'An error occurred while posting activity.',
  TOAST_POSTING_EVENT: 'Error posting event',
  TOAST_DL_GENERATE_ERROR_MESSAGE:
    'Ooops!! There is some problem in accessing Navigator. Please try again by refreshing the browser.',
  HOME_DEFAULT_CONTAINER_TEXT: 'I’m ping, your AI assistant.',
  HOME_FIRST_CONTAINER_TEXT: 'Ready to assist with all corporate issues.',
  HOME_SECOND_CONTAINER_TEXT: " Just ask, I'm on it!",
  HOME_THIRD_CONTAINER_TEXT: '',
  HOME_PROMPTS_TEXT: 'Frequent prompts your colleagues are asking about.',
  HOME_CHAT_INPUT_PLACEHOLDER: 'Just ask',
  CHAT_INPUT_PLACEHOLDER: 'Just ask',
  NEW_CHAT_MODAL_TEXT: 'Are you sure you want to start a new chat?',
  NEW_CHAT_MODAL_HEADER_TEXT: 'Confirmation',
  NEW_CHAT_MODAL_CONFIRM_TEXT: 'Yes',
  NEW_CHAT_MODAL_CANCEL_TEXT: 'No',
  SESSION_EXPiRED_ERROR_TITLE: 'Session Expired',
  SESSION_EXPiRED_ERROR_MESSAGE:
    'Your session has expired. Please start a new conversation',
  SESSION_EXPiRED_ERROR_ACTIVE_BTN: 'Start New Chat',
  SESSION_EXPiRED_ERROR_CANCEL_BTN: 'Cancel',
  SESSION_EXPiRED_ERROR_HOME_PAGE_TITLE: 'Service Unavailable',
  SESSION_EXPiRED_ERROR_HOME_PAGE_MESSAGE:
    'Ooops!! Service is currently unavailable. Please try again.',
  SESSION_EXPiRED_ERROR_HOME_PAGE_ACTIVE_BTN: 'Retry',
  OPEN_ID_EXPIRY_TITLE: 'Session Expiry',
  OPEN_ID_EXPIRY_MESSAGE:
    'Your Session will be expired in 10 minutes. Please start a new Conversation.',
  OPEN_ID_EXPIRY_ACTIVE_BTN: 'Start New Chat',
  OPEN_ID_EXPIRY_CANCEL_BTN: 'Close',
  ACTIVITY_TIME_OUT_MESSAGE:
    'Error in processing user request. Please try opening a new chat or open support ticket in the following ',
  WS_TIME_OUT_MESSAGE:
    'We’re experiencing a delay in processing your request. Please try again. If the issue persists, open a new chat or submit a support ticket using the following link: ',
  THUMBS_UP_GIF_PATH: './assets/gifs/thumbs-up-like.gif',
  THUMBS_UP_FILL_PATH: './assets/icons/thumb-on-fill.svg',
  WS_TIMEOUT: 125000, // 125 SECONDS
  TOKEN_TIMEOUT: 40 * 60 * 1000, // 40 MINUTES
  TOKEN_REFRESH_FOR_BACKEND: 50 * 60 * 1000, // 50 MINUTES
  CLOSE_CONVERSATION_MESSAGE: 'This conversation has ended. Let’s start a ',
  LA_CONFIRM_MODAL_TEXT:
    'Are you sure you want to cancel the Live Agent connection?',
  LA_CONFIRM_MODAL_HEADER_TEXT: 'Confirmation',
  LA_CONFIRM_MODAL_CONFIRM_TEXT: 'Yes',
  LA_CONFIRM_MODAL_CANCEL_TEXT: 'No',
  CHAT_BOT_URL: '/chat-bot',
  HISTORY_CONVERSATION_MESSAGE: 'This conversation is outdated. Some information may have changed.',
};

export const MODAL_POP_UP_CONSTANTS = {
  TITLE: 'Conformation',
  HEADING: 'Heading back to Ping.',
  DESCRIPTION:
    "Your current conversation won't be saved, so you'll need to start fresh.",
  PRIMARY_CTA: 'Yes',
  SECONDARY_CTA: 'No',
};

export const HELP_CONSTANTS = {
  FAQ_LABEL_TEXT: 'FAQ',
  FAQ_SUB_LABEL_TEXT: 'Everything you need to know about our new AI chat',
  TIPS_LABEL_TEXT: 'Tips',
  TIPS_SUB_LABEL_TEXT:
    'Some tips that will help improve you experience with our AI chat',
  LAST_LINE:
    'Remember, Ping is continuously improving to provide better results. Please send your feedback by clicking thumbs up/down and help us improve.',
  SEARCH_INPUT_PLACEHOLDER: 'Search here',
  NOTE: 'Ping is AI-bot: Review references and use discretion before relying on output. Avoid sharing personal data',
};

export const MAINTENANCE_CONSTANTS = {
  MAINTENANCE_TITLE: 'Ping maintenance notice',
  MAINTENANCE_MESSAGE_1: 'Ping under Maintenance till',
  MAINTENANCE_MESSAGE_1_1:
    ' Ping is currently undergoing scheduled maintenance to enhance your experience. ',
  MAINTENANCE_MESSAGE_2: 'Maintenance Window:  ',
  MAINTENANCE_MESSAGE_3:
    'During this time, Ping will be temporarily unavailable.',
  MAINTENANCE_MESSAGE_4: 'Need immediate assistance?',
  MAINTENANCE_MESSAGE_5: 'Open a',
  MAINTENANCE_MESSAGE_6: ' or call support team at ',
  MAINTENANCE_MESSAGE_7:
    'We appreciate your patience and will have Ping back up and running \nas soon as possible ! \n\n Amdocs IT',
  MAINTENANCE_START_TIME: '24/12/2025 05:00 PM', // DD/MM/YYYY HH:MM AM/PM format use 24hr format
  MAINTENANCE_END_TIME: '24/12/2025 9:00 PM', // DD/MM/YYYY HH:MM AM/PM format
  MAINTENANCE_LINK_TEXT: 'ticket',
  MAINTENANCE_LINK_TEXT_2: '62000',
  MAINTENANCE_LINK:
    'https://amdocsprodmain.service-now.com/ta',
  MAINTENANCE_LINK_2:
    'https://teams.microsoft.com/l/call/0/0?users=AmdocsSupport@Amdocs.onmicrosoft.com',
};

/*
   Optimized Logger Messages:
  - IU-TEM → (Idle User) - Token Exp Modal
  - C - {streamNumber} - {activityId}, {conversationId} → Chunk - {streamNumber} - {activityId}, {conversationId}
  - LC - {activityId} → Last Chunk - {activityId}
  - MASK - {activityId} → ****** {activityId}
  - EOC-S → EOC success by BOT
  - TSTR-WSL - {errMsg} → Toaster Shown (wsListener) - {errMsg}
  - ERR-BRT-TSTR → Err - Bot Response Timeout (Toaster Shown)
  - TE-TNF-TEM → Token Exp (Token Not Found) (Token Exp Modal)
  - TE-TEM → Token Expired (Token Exp Modal)
  - PAC - {msg} - {cardId} → Posting Adaptive Card - {msg} - {cardId}
  - PA - {activityType} CAID: {clientActivityID} → Posting Activity - {activityType} clientActivityID: {clientActivityID}
  - ERR-TSTR-DLPA-CAID: {clientActivityID} Retry → Error (Toaster Shown dl post activity) - clientActivityID: {clientActivityID} Retry
  - ERR-CAID: {clientActivityID} MSG: {errMsg} → Error - clientActivityID: {clientActivityID} Error Msg: {errMsg}
  - TSTR-DLPA-CAID: {clientActivityID} MSG: {errorMessage} → Toaster Shown (dl post activity) - clientActivityID: {clientActivityID} Error Msg: {errorMessage}
  - EOC-SB → EOC Successfully by BOT
  - EOC-I → EOC Initiated
  - EOC-S → EOC Successfully
  - EOC-F - {errMsg} → EOC Failed - {errMsg}
  - TSTR-EOC - {errorMessage} → Toaster Shown (EOC) - {errorMessage}
  - EOC-I → EOC Initiated
  - EOC-SB-SB → EOC Success Sent via sendBeacon
  - EOC-F-SB → EOC Failed via sendBeacon
  - TSTR-FB - {errorMessage} → Toaster Shown (Feedback) - {errorMessage}
  - GDLT → Gen DL Token
  - TG - EXP: {expDate} CID: {conversationId} → Token Gen - Exp: {expDate}, {conversationId}
  - TG-F-POP - {err} → Token Gen Fail (Pop-up) - {err}
  - NCS → ---- New Conversation Started ----
  - TRB → Token Refreshed for Backend
  - TRB-F - {err} → Token Refresh for Backend Failed - {err}
  - RT - {toast} → Removing Toast {toast}
  - RAT → Removing All Toaster Messages
  */
